const boolValues = ['moveInOut', 'recurring', 'sanitation', 'standard', 'additionalInfo', 'baseboards', 'blinds', 'oven', 'fridge', 'pets', 'windows', 'beds']

export function encode(data) {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return formData;
}

export function parseBoolValues(values) {
  let output = {};

  Object.keys(values).forEach(val => {
    if (boolValues.includes(val)) {
      if (values[val]) {
        output[val] = 'Yes';
      } else {
        output[val] = 'No';
      }
    } else {
      output[val] = values[val];
    }
  })

  return output;
}

// Google Enhanced E-commrce functions

//Checkout steps funnel
export function GoogleEcommCheckout( stepName, cleaningType) {
  if (typeof window !== `undefined`) {
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': { 'step': stepName, "action": "checkout"},
          'products': [{
            'name': cleaningType,
          }]
        }
      }
    });
  }

}

// Pruchase event 
export function GoogleEcommPurchase( price, cleaningType) {
  if (typeof window !== `undefined`) {
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      'event': 'booking',
      'conversionValue': price,
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': `${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 3)}_${Math.floor(Math.random() * 1000000)}`,                           // Transaction ID. Required for purchases and refunds.
            'revenue': price,                             // Total transaction value (incl. tax and shipping)
          },
          'products': [{                                // List of productFieldObjects.
            'name': cleaningType,                         // Name or ID is required.,
            'price': price, 
            'quantity': 1,                         // Optional fields may be omitted or set to empty string.
          }]
        }
      }
    });
  }

}
